import { Button, ButtonProps } from 'react-bootstrap';
import { Store } from '@website/Store';
import { useContext } from 'react';

export function AdminButton({ children, ...props }: ButtonProps) {
  // Hide if the user is not an admin
  const { state } = useContext(Store);
  const isAdmin = state.user?.roles.includes('admin');
  if (!isAdmin) {
    return null;
  }

  return (
    <Button style={{ position: 'relative' }} variant="danger" {...props}>
      <div
        style={{
          position: 'absolute',
          bottom: -3,
          right: 3,
          background: 'transparent',
          fontSize: 8,
          letterSpacing: 1,
          opacity: 0.8,
          textTransform: 'none',
        }}
        className="text-white"
      >
        <strong>Admin</strong>
      </div>
      {children}
    </Button>
  );
}
